import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ApiResponse } from 'types';

interface UpdatePasswordParams {
  password: string;
  newPassword: string;
}

type UpdatePassword = (params: UpdatePasswordParams) => Promise<ApiResponse>;

const updatePassword: UpdatePassword = async ({ password, newPassword }) => {
  const { data } = await apiClient.put(API_END_POINT.USER.UPDATE_PASSWORD, {
    oldUserPw: password,
    newUserPw: newPassword,
  });

  return data;
};

export default updatePassword;
